import type FeaturedNavigation from './FeaturedNavigation';

import { appConfig } from '../../../../appConfig';
import { BrowserSize } from '../../../../utility/browser';
import { HeaderCartErrorNotice } from '../../../cart/components/molecules/CartErrorNotice';
import { useFromBrowserMediaQuery } from '../../../common/components/atoms/ResponsiveBreakpoints';
import { UserType } from '../../../common/flow/user/userModels';
import { useUserTypeQuery } from '../../../common/hooks/useUserQueries';
import EpiQuickNavigatorButton from './EpiQuickNavigatorButton';
import HeaderBanner from './HeaderBanner';
import HeaderLeftNav from './HeaderLeftNav';
import HeaderRightNav from './HeaderRightNav';

const HeaderStickyBanner = (props: {
    featuredNavigation: {
        items: React.ComponentProps<typeof FeaturedNavigation>['items'];
    };
    headerTheme: 'darkGreen' | 'black';
    stayAfterLoginLogoutRedirect: boolean;
    searchSlot?: React.ReactNode;
}) => {
    const isFromLarge = useFromBrowserMediaQuery(BrowserSize.lg);

    const { data: userType } = useUserTypeQuery();
    const isPunchout = userType === UserType.punchout;

    const disableMyFavoritesMenu = isPunchout || appConfig.coopUserSettings.isShoppingForMunicipal;

    return (
        <>
            <HeaderBanner.Banner headerTheme={props.headerTheme}>
                <HeaderBanner.LeftSlot>
                    {isFromLarge && (
                        <HeaderBanner.LeftNav>
                            <HeaderLeftNav
                                disableSiteNavigation={false}
                                navigationItems={props.featuredNavigation?.items}
                            />
                        </HeaderBanner.LeftNav>
                    )}
                </HeaderBanner.LeftSlot>
                {props.searchSlot && (
                    <HeaderBanner.CenterSlot>{props.searchSlot}</HeaderBanner.CenterSlot>
                )}
                <HeaderBanner.RightSlot>
                    {isFromLarge && (
                        <HeaderBanner.RightNav>
                            <HeaderRightNav
                                disableMyFavoritesMenu={disableMyFavoritesMenu}
                                stayAfterLoginLogoutRedirect={props.stayAfterLoginLogoutRedirect}
                                headerTheme={props.headerTheme}
                            />
                        </HeaderBanner.RightNav>
                    )}
                </HeaderBanner.RightSlot>
                <EpiQuickNavigatorButton />
            </HeaderBanner.Banner>
            <HeaderCartErrorNotice />
        </>
    );
};

export default HeaderStickyBanner;
